<template>
  <div id="Member">
    <div v-for="member in memberList" style="width: 220px; margin-right: 67px;margin-top: 20px;">
      <img style="width: 220px;height: 280px;object-fit: cover;border-radius: 5px;box-shadow: 5px 5px 5px rgba(0, 0, 0, .5);" :src="member.profile"/>
      <p style="line-height: 24px;">姓名：{{member.member_name}}</p>
      <p style="line-height: 24px;">职务：{{member.post}}</p>
      <p v-html="member.intro" style="line-height: 24px;"></p>
    </div>
  </div>
</template>

<script>
import {getAssociationMemberList} from "@/request/web/association";

export default {
  name: "Member",
  data() {
    return {
      memberList: []
    }
  },
  created() {
    this.onGetAssociationMemberList()
  },
  methods: {
    onGetAssociationMemberList() {
      getAssociationMemberList({
        pageIndex: 1,
        pageSize: 999,
        filter: {}
      }).then(res=> {
        res.data.data.list.map(item=> {
          item.intro = item.intro.replace(/\\n/g, '<br>').replace(/\n/g, '<br>');
          this.memberList.push(item)
        })
      })
    }
  }
}
</script>

<style scoped>
#Member {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: start;
}
</style>
